import type { MPARequest } from '@repo/api-gw-sdk';

const getResourceId = (request: MPARequest | null | undefined) => {
  const path = request?.requestPath;
  if (!path) {
    return null;
  }
  const match = /\/(?:resources|inventory)\/([^/?]+)/.exec(path);
  return match?.[1] ?? null;
};

export const getResourceIds = (
  request: MPARequest | null | undefined
): string[] => {
  if (request?.resourceIds?.length) {
    return request.resourceIds;
  }
  const single = getResourceId(request);
  return single ? [single] : [];
};
